import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useCallback } from 'react';
const CreateSpaceModalLazy = Dynamic(async () => {
    const { CreateSpaceModal } = await import('#pplx/frontend/apps/ask/spaces-redesign/create-space-modal/CreateSpaceModal.js');
    return { default: CreateSpaceModal };
}, {});
export function useCreateSpaceModal() {
    const { openModal } = useModalContext();
    const openCreateSpaceModal = useCallback((args = {}) => {
        openModal(CreateSpaceModalLazy, args, { replace: true });
    }, [openModal]);
    return { openCreateSpaceModal };
}
//# sourceMappingURL=useCreateSpaceModal.js.map